import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { setProfileModalOpen, update_profile, get_profile_list } from '../../../store/profile/profileSlice';
import ProfileTable from './ProfileTable';

import { isAuth } from '../../../helpers/cookies';

const ProfileModal = () => {
    const dispatch = useDispatch();
    const { is_profile_modal_open, profile_list, common_loading } = useSelector((state) => state.profile);
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (is_profile_modal_open) {
            dispatch(get_profile_list({ page: 1 }));
        }
    }, [is_profile_modal_open, dispatch]);

    const handleClose = () => {
        dispatch(setProfileModalOpen(false));
    };

    const handleProfileUpdate = async (payload) => {
        try {
            const res = await dispatch(update_profile(payload));
            const data = res?.payload?.data;

            if (data && (data.type && data.loc && data.msg)) {
                console.error("Profile validation failed (Object):", data);
                return false;
            }
            if (Array.isArray(data) && data.length > 0 && data[0].type && data[0].loc && data[0].msg) {
                console.error("Profile validation failed (Array):", data);
                return false;
            }
            if (data && data.detail && Array.isArray(data.detail)) {
                console.error("Profile validation failed (Detail):", data);
                return false;
            }
            return data ? true : false;
        } catch (err) {
            console.error('Profile update failed:', err);
            return false;
        }
    };

    // Safely select the user profile
    let userProfile = {};
    let userId = user?.id || isAuth()?.id;

    if (Array.isArray(profile_list) && profile_list.length > 0) {
        // Try to find the profile matching the logged-in user
        const found = userId ? profile_list.find(p => p.id === userId) : null;
        if (found) {
            userProfile = found;
        } else {
            // Fallback to the first item if no match found
            userProfile = profile_list[0];
        }
    }

    // If we have a selected profile, prefer its ID for the update action
    if (userProfile && userProfile.id) {
        userId = userProfile.id;
    }

    // Ensure userProfile is not a Pydantic error object (extra safety, though slice should handle it)
    if (userProfile && (userProfile.type || userProfile.loc)) {
        console.error("ProfileModal encountered error object:", userProfile);
        userProfile = {};
    }

    return (
        <Dialog
            open={is_profile_modal_open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    My Profile
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <ProfileTable
                    handleProfileModal={handleClose} // Pass handleClose to close modal after update if needed
                    handleProfileUpdate={handleProfileUpdate}
                    profile_list={userProfile}
                    user_id={userId}
                    page={0} // Not really used for single profile edit but kept for prop compatibility
                />
            </DialogContent>
        </Dialog>
    );
};

export default ProfileModal;
